import { lazy } from 'react';
import { Route, Switch } from 'react-router-dom';
import { useRouteMatch } from 'react-router-dom/cjs/react-router-dom.min';

const Products = lazy(() => import('../../container/products/Products'));
const EditProduct = lazy(() => import('../../container/products/overview/EditProduct'));

function ProductsRoutes() {
  const { path } = useRouteMatch();
  return (
    <Switch>
      <Route path={`${path}`} component={Products} />
      <Route path={`${path}/v1/edit/:id`} component={EditProduct} />
    </Switch>
  );
}

export default ProductsRoutes;
